export interface WidgetController {
  openWithMessage: (message: string, autoSend?: boolean) => void;
}

export const NETAI_WIDGET_PREFILL_EVENT = 'netai-widget-prefill';
export const PENDING_MESSAGE_KEY = 'pendingMessage';
export const PENDING_AUTO_SEND_KEY = 'pendingAutoSend';
